const CATEGORY = {
  ENDPOINTS: {
    CATEGORY: '/categories',
    SUBCATEGORY: '/subcategories',
  },
  FILTERS: {
    FILTER_BY: 'Filtrar por',
    RESULT_FOR: 'Resultado para:',
  },
  HIDE: 'Digite o nome da categoria ou subcategoria que você deseja ocultar.',
  FILTER_RESET: 'Limpar filtro',
  OFFERS: {
    SERVER_LIMIT: 12,
    CLIENT_LIMIT: 24,
  },
  SEE_ALL_CATEGORIES: 'Ver todas as categorias',
};

export const NO_OFFER_FOR_CATEGORY_FOUND_MESSAGE =
  'Ops! Infelizmente não temos nenhuma oferta para esta categoria.';

export const NO_OFFER_FOR_FILTER_FOUND_MESSAGE =
  'Ops! Infelizmente não temos nenhuma oferta ativa relacionada a esse filtro.';

export default CATEGORY;
